import { BUSINESS_PAYMENT_PREFIX } from '@oy/types';
import { getOverbookingInfo } from 'src/clients';
import BANKS from 'src/constants/banks.json';
import { useEnv, useProductConfigs } from 'src/hooks';
import useSWR from 'swr';

export const useOverbookingData = (isUsingNewOverbook = false) => {
  const { isProdEnv } = useEnv();
  const { data: dataConfig } = useProductConfigs();

  const oldDataConfig = {
    overbookingVendorId: dataConfig.find(
      config =>
        config.service === 'API_DISBURSE' &&
        config.parameter === 'OVERBOOKING_BANK_CODE',
    )?.value,
    overbookingAccountNumber: dataConfig.find(
      config =>
        config.service === 'API_DISBURSE' &&
        config.parameter === 'OVERBOOKING_ACCOUNT_NUMBER',
    )?.value,
  };

  const { data } = useSWR(
    isUsingNewOverbook && isProdEnv
      ? `${BUSINESS_PAYMENT_PREFIX}/account/overbooking-info`
      : null,
    () => getOverbookingInfo(),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  if (!isProdEnv) {
    return {
      data: {
        bankName: 'Bank Artha Graha International',
        accountNumber: '213982498320945',
      },
    };
  }

  if (!isUsingNewOverbook) {
    return {
      data: {
        bankName:
          BANKS.find(
            bank => bank.bankCode === oldDataConfig.overbookingVendorId,
          )?.bankName ?? '',
        accountNumber: oldDataConfig.overbookingAccountNumber ?? '',
      },
    };
  }

  return {
    data: {
      bankName:
        BANKS.find(
          bank => bank.bankCode === data?.data.data?.overbooking_bank_code,
        )?.bankName ?? '',
      accountNumber: data?.data.data?.overbooking_account_number ?? '',
    },
  };
};
